<template>
  <div>
    <div class="f1" v-if="disabled">{{value[0]}} - {{value[1]}}</div>
    <el-date-picker
    v-else
      v-model="value"
      type="daterange"
      range-separator="-"
      :start-placeholder="startP"
      :end-placeholder="endP"
      :format="format"
      :value-format="valueFormat"
      @change="handleChange"
      >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  props: ['column', 'scope'],
  data() {
    const {
      disabled,
      label,
      format,
      valueFormat
    } = this.column
    const defFormat = 'yyyy-MM-dd'
    return {
      disabled: !!disabled,
      startP: `开始${label}`,
      endP: `结束${label}`,
      value: this.scope.row[this.column.prop] || '',
      format: format || defFormat,
      valueFormat: valueFormat || defFormat
    }
  },
  watch: {
    scope({ row }) {
      this.value = row[this.column.prop]
    }
  },
  methods: {
    handleChange(v) {
      this.$emit('on-edit', v, this.column.prop, this.scope.$index)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./date.scss";
</style>
